import type { ReactNode } from 'react';
import { X } from 'lucide-react';

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
};

export function Modal({ open, onClose, title, children, footer, size = 'md' }: Props) {
  if (!open) return null;
  const sizes: Record<string, string> = {
    sm: 'max-w-md',
    md: 'max-w-xl',
    lg: 'max-w-3xl',
    xl: 'max-w-5xl',
  };
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/50 p-0 sm:p-4">
      <div className={`w-full ${sizes[size]} bg-white rounded-t-2xl sm:rounded-xl shadow-xl flex flex-col max-h-[92vh] sm:max-h-[90vh]`}>
        <div className="flex items-center justify-between px-4 sm:px-5 py-3 sm:py-4 border-b border-slate-100">
          <h3 className="text-base font-semibold pr-2 truncate">{title}</h3>
          <button className="p-1 rounded hover:bg-slate-100 shrink-0" onClick={onClose} aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>
        <div className="p-4 sm:p-5 overflow-auto">{children}</div>
        {footer && (
          <div className="px-4 sm:px-5 py-3 border-t border-slate-100 flex flex-wrap justify-end gap-2">{footer}</div>
        )}
      </div>
    </div>
  );
}
